import React, { useState, useRef, useEffect } from 'react';
import styles from './BadgeDropdown.module.scss';

export type BadgeDropdownItem = {
  id: string;
  label: string;
  disabled?: boolean;
  danger?: boolean;
};

type BadgeDropdownProps = {
  trigger: React.ReactNode;
  items: BadgeDropdownItem[];
  className?: string;
  dropdownClassName?: string;
};

const BadgeDropdown: React.FC<BadgeDropdownProps> = ({
  trigger,
  items,
  className = '',
  dropdownClassName = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`${styles.badgeDropdown} ${className}`} ref={dropdownRef}>
      <div 
        className={styles.trigger} 
        onClick={toggleDropdown}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {trigger}
      </div>
      
      {isOpen && (
        <div 
          className={`${styles.dropdown} ${dropdownClassName}`}
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className={styles.dropdownContent}>
            {items.map((item) => (
              <div 
                key={item.id} 
                className={`
                  ${styles.dropdownItem} 
                  ${item.disabled ? styles.disabled : ''}
                  ${item.danger ? styles.danger : ''}
                `}
              >
                {item.disabled && <span className={styles.disabledIcon}>○</span>}
                {item.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BadgeDropdown;
